import { sentryLog } from "../../../tools/sentry";
import { formSet } from "../../gvc/testNewForm/utils";
import { validationFns } from "../../../components/form/validations";
import { LocationInput } from "../../../schema/types/location/input";

export function getValidator(id: string) {
  return async function validator(v: LocationInput): Promise<boolean | null> {
    // setup
    formSet(id, `meta.valid`, false);
    formSet(id, `meta.validating`, true);
    formSet(id, `errors`, {});
    formSet(id, `warnings`, {});

    const e: Partial<Record<string, { message: string }>> = {};
    const w: Partial<Record<string, { message: string }>> = {};

    function setError(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      e[path] = { message: message };
    }

    function setWarning(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      const currentWarning = w[path];
      if (currentWarning) {
        return;
      }
      w[path] = { message: message };
    }

    // setup end

    try {
      const fs = validationFns("Name");
      for (const f of [fs.required, fs.name]) {
        const r = f(v.name);
        if (r !== true) {
          setError(`name`, r);
        }
      }

      if (v.description.length > 250) {
        setError(`description`, `Description can be at most 250 characters`);
      }

      // tags start
      for (const tagIndexStr in v.tags) {
        const tagIndex = Number(tagIndexStr);
        const tag = v.tags[tagIndex];
        if (!tag.name) {
          setError(`tags.${tagIndex}.name`, "Tag key is required");
          setError(`tagsroot`, "Tag keys are required");
        }
      }

      if (v.tags.length > 50) {
        setError(`tagsroot`, "Tags cannot be more than 50 items");
      }
      // tags end

      // setup
      for (const path of Object.keys(e)) {
        const value = e[path];
        formSet(id, `errors.${path}`, value);
      }
      for (const path of Object.keys(w)) {
        const value = w[path];
        formSet(id, `warnings.${path}`, value);
      }

      const hasErrors = Object.keys(e).length > 0;

      formSet(id, `meta.valid`, !hasErrors);
      formSet(id, `meta.validating`, false);

      return hasErrors;
    } catch (e) {
      sentryLog("location validator error", { "data.error": e.message });
      formSet(id, `errors`, { root: { message: "An unexpected error occurred. This has been logged and we will fix it." } });
      return true;
    }
  };
}
